module.exports = __webpack_public_path__ + "static/img/paifengTrue.7b514ffa.png";